export { default } from "./ScoutingReportRowContainer";
